import React from 'react';
import Tabs from '../../../../components/Tabs';
import TagHistoryNavbar from '../TagHistoryNavbar';
import { TAG_RELATED_ITEM_TYPE } from '../../../../constants/service/app/tagConstants';
import TagHistoryRelatedItemList from '../../common/TagHistoryRelatedItemList';
import TagHistoryActivityHistory from '../TagHistoryActivityHistory';
import TagHistoryInfo from '../TagHistoryInfo';
import { tagRelatedItemColumns } from './columns';
import './TagHistoryWrap.scss';

const TagHistoryWrap = (props) => {
  const { tagHistory, setData, getTagHistoryRelatedItemList, getTagPreviewData, getProductSubCategoryList } = props;
  const { tagInfo, activityHistory, relatedItemList } = tagHistory;

  return (
    <div className="tag-history-wrap">
      {/* 하단 네브바 */}
      <TagHistoryNavbar tagId={tagInfo.tagId} status={tagInfo.status} getTagPreviewData={getTagPreviewData} />

      {/* 태그 상세 */}
      <Tabs
        list={[
          {
            title: '태그 정보',
            content: <TagHistoryInfo tagInfo={tagInfo} />,
          },
          {
            title: '활동 내역',
            content: <TagHistoryActivityHistory activityHistory={activityHistory} />,
          },
          {
            title: '태그에 연결된 상품 리스트',
            content: (
              <TagHistoryRelatedItemList
                setData={setData}
                tagRelatedItemType={TAG_RELATED_ITEM_TYPE.PRODUCT}
                relatedItemList={relatedItemList[TAG_RELATED_ITEM_TYPE.PRODUCT]}
                getTagHistoryRelatedItemList={getTagHistoryRelatedItemList}
                getProductSubCategoryList={getProductSubCategoryList}
                columns={tagRelatedItemColumns}
              />
            ),
          },
          {
            title: '태그에 연결된 브랜드 리스트',
            content: (
              <TagHistoryRelatedItemList
                setData={setData}
                tagRelatedItemType={TAG_RELATED_ITEM_TYPE.STORE}
                relatedItemList={relatedItemList[TAG_RELATED_ITEM_TYPE.STORE]}
                getTagHistoryRelatedItemList={getTagHistoryRelatedItemList}
                columns={tagRelatedItemColumns}
              />
            ),
          },
          {
            title: '태그에 연결된 기획전 리스트',
            content: (
              <TagHistoryRelatedItemList
                setData={setData}
                tagRelatedItemType={TAG_RELATED_ITEM_TYPE.EVENT}
                relatedItemList={relatedItemList[TAG_RELATED_ITEM_TYPE.EVENT]}
                getTagHistoryRelatedItemList={getTagHistoryRelatedItemList}
                columns={tagRelatedItemColumns}
              />
            ),
          },
          {
            title: '태그에 연결된 상품 후기 리스트',
            content: (
              <TagHistoryRelatedItemList
                setData={setData}
                tagRelatedItemType={TAG_RELATED_ITEM_TYPE.REVIEW}
                relatedItemList={relatedItemList[TAG_RELATED_ITEM_TYPE.REVIEW]}
                getTagHistoryRelatedItemList={getTagHistoryRelatedItemList}
                columns={tagRelatedItemColumns}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default TagHistoryWrap;
